<template>
    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row  ">
                    <div class="col-12">
                        <ul class="breadcrumb">
                            <slot name="path"></slot>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
   name: 'PathComp'
  }
</script>